<template>
  <div class="resource">
    <el-form :model="fileForm" :rules="rules" ref="fileForm" v-if="show">
      <!-- <el-form-item label="文件名" prop="fileName">
        <el-input style="width: 10.25rem;margin-left: 0.785rem;" placeholder="请输入文件名" v-model="fileForm.fileName" clearable></el-input>
      </el-form-item> -->
      <el-form-item class="form-sc" label="文件描述:" prop="introduce">
        <el-input :autosize="{ minRows: 10,}" maxlength="500" placeholder="请输入内容" show-word-limit style="margin: left 0.729rem;" type="textarea" v-model="fileForm.introduce"></el-input>
      </el-form-item>
      <el-form-item label="联系方式:" prop="userContact" style="display:flex;">
        <el-input placeholder="请输入手机或者邮箱" style="width: 34.896rem;" v-model="fileForm.userContact"></el-input>
      </el-form-item>
      <el-form-item label="上传文件:">
        <el-upload :auto-upload="false" :on-change="uploadFile" action="#" class="upload-demo" drag multiple ref="uploadFileName" style="margin-left: 0.789rem;" with-credentials>
          <img alt="" class="upimg" src="../../../assets/image/reader/upimg.png">
          <div v-show="chunkCountNow > 0">上传：{{fileForm.fileName}}</div>
          <el-progress :percentage="chunkCountNow" v-show="chunkCountNow > 0"></el-progress>
          <div class="el-upload__text">将文件拖到此处，或<em :loading="loadingFile">点击上传</em></div>
        </el-upload>
      </el-form-item>
      <div style="display: flex;flex-wrap: wrap;">
        <div :key="index" v-for="(item, index) in selecdRource">
          <div class="buying-source" style="margin-bottom: 1rem;">
            <div @click="sourceClick(item,index)" class="buying-source-close">
              <i class="el-icon-close"></i>
            </div>
            {{ item.fileName }}
          </div>
        </div>
      </div>
      <el-button @click="submitForm('fileForm')" class="submitBtn">保存</el-button>
    </el-form>
    <div v-else>
      <el-empty :description="empty"></el-empty>
    </div>
  </div>
</template>

<script>
  import SparkMD5 from "spark-md5";
  import axios from 'axios'
  import {addUploadInfo, checkFile, deleteFileOperation, getReaderUploadPermission, listLogByReaderId, mergeFile} from '../../../utils/router/reader.api'

  const chunkSize = 1 * 1024 * 1024;//定义分片的大小 暂定为1M，方便测试
  export default {
    data() {
      return {
        fileForm: {
          introduce: '',
          userContact: '',
          fileName: '',
        },
        rules: {
          introduce: [{message: "请添加文件描述", trigger: "blur", required: true,}],
          userContact: [{message: "请输入联系方式", trigger: "blur", required: true,}],
          fileName: [{required: true, message: "请输入文件名", trigger: "blur"}],
        },
        uid: '',
        fileUploadList: [],
        chunkCountNow: 0,
        loadingFile: false,
        clearFile: false,
        rootUrl: "",
        show: true,
        showUpFil: true,
        empty: '该账号暂无权限',
        selecdRource: []
      }
    },
    methods: {
      getPrivilege() {
        // this.$store.state.userInfo.userId
        getReaderUploadPermission({readerId: this.$store.state.userInfo.userId}).then(res => {
          if (res && res.data.code === 200) {
            if (!res.data.data) {
              this.show = false
            } else {
              this.rootUrl = res.data.data.filePath
              this.uid = res.data.data.userId
            }
          }
        })
      },
      async uploadFile(File) {
        File.state = false;
        if (this.fileUploadList.findIndex(_ => _.name == File.name) == -1) {
          this.fileUploadList.push(File)
        }

        //中断上传
        if (this.clearFile || this.loadingFile) {
          this.$refs.uploadFileName.clearFiles();
          return
        }
        //上传文件
        this.loadingFile = true
        let self = this
        const file = File.raw
        //文件大小(大于10m再分片哦，否则直接走普通文件上传的逻辑就可以了，这里只实现分片上传逻辑)
        const fileSize = File.size
        // 可以设置大于多少兆可以分片上传，否则走普通上传
        //计算当前选择文件需要的分片数量
        const chunkCount = Math.ceil(fileSize / chunkSize);
        // if (fileSize <= chunkSize) {
        //  axios.post('/portal/reader/upload/uploadFileOption', {
        //   file:File.name,
        //   md5: this.getFileMd5(file, chunkCount),
        //   chunk:chunkCount,
        //   toPath:this.rootUrl,
        //   uid:this.uid
        //  }, {
        //     headers: {"Content-Type": "multipart/form-data"}
        //   })
        //   return
        // }

        //获取文件md5
        const fileMd5 = await this.getFileMd5(file, chunkCount);
        const initUploadParams = {
          "fileMd5": fileMd5, //文件的md5
          "toPath": this.rootUrl, //文件名
          "totalChunks": chunkCount, //分片的总数量
          "readerId": this.$store.state.userInfo.userId
        }
        // 调用后端检查文件上传情况接口
        await checkFile(initUploadParams).then(async res => {
          // 获取后端返回的已上传分片数字的数组
          let uploaded = res.data.data
          // 上传的序号按顺序上传，为0则说明文件是第一次上传，分片开始序号从0开始
          let num = uploaded
          // 当前为顺序上传方式，若要测试并发上传，请将103 行 await 修饰符删除即可
          for (let i = num; i < chunkCount; i++) {
            //中途中断
            if (this.clearFile) {
              return
            }
            //进度
            this.chunkCountNow = Math.round(i / chunkCount * 100);
            this.fileForm.fileName = File.name
            //分片开始位置
            let start = i * chunkSize
            //分片结束位置
            let end = Math.min(fileSize, start + chunkSize)
            //取文件指定范围内的byte，从而得到分片数据
            let _chunkFile = File.raw.slice(start, end)
            let formData = new FormData()
            formData.append('md5', fileMd5)
            // formData.append('filename', File.name)
            formData.append('filename', this.fileForm.fileName)
            formData.append('totalChunks', chunkCount)
            formData.append('chunk', i)
            formData.append('totalSize', fileSize)
            formData.append('file', _chunkFile)
            formData.append('toPath', this.rootUrl)
            formData.append('uid', this.uid)

            // 通过await实现顺序上传
            await this.getMethods(formData);
          }
          // 文件上传完毕，请求后端合并文件并传入参数
          await self.composeFile(fileMd5, File.name, chunkCount)
        })
      },
      async composeFile(fileMd5, fileName, count) {
        //开始请求后端合并文件
        let res = await mergeFile({
          "fileMd5": fileMd5, //文件的md5
          "fileName": fileName, //文件名
          "totalChunks": count, //分片的总数量
          "toPath": this.rootUrl, //路径
          "readerId": this.$store.state.userInfo.userId
        })

        if (res.data.code == 200) {
          this.chunkCountNow = 100;
          this.loadingFile = false;
          this.$refs.uploadFileName.clearFiles();
          this.fileUploadList.map(data => {
            if (data.name == fileName) {
              data.state = true;
            }
            //接着上传下一条
            if (!data.state) {
              this.uploadFile(data)
            }
            return data;
          })
        } else {
          this.loadingFile = false;
        }
      },
      getMethods(formData) {
        //上传文件方法
        return axios.post('/portal/reader/upload/uploadFileOption', formData, {
          headers: {"Content-Type": "multipart/form-data"}
        })
      },
      getFileMd5(file, chunkCount) {
        //获取文件MD5
        return new Promise((resolve, reject) => {
          let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
          let chunks = chunkCount;
          let currentChunk = 0;
          let spark = new SparkMD5.ArrayBuffer();
          let fileReader = new FileReader();

          fileReader.onload = function (e) {
            spark.append(e.target.result);
            currentChunk++;
            if (currentChunk < chunks) {
              loadNext();
            } else {
              let md5 = spark.end();
              resolve(md5);
            }
          };
          fileReader.onerror = function (e) {
            reject(e);
          };

          function loadNext() {
            let start = currentChunk * chunkSize;
            let end = start + chunkSize;
            if (end > file.size) {
              end = file.size;
            }
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
          }

          loadNext();
        });
      },
      cancelUpload() {
        this.clearFile = true;

      },

      submitForm(fileForm) {
        console.log( this.fileForm.fileName);
        this.$refs[fileForm].validate((valid) => {
          if (valid) {
            addUploadInfo({
              readerId: this.$store.state.userInfo.userId,
              description: this.fileForm.introduce,
              telephone: this.fileForm.userContact,
              filePath: '/reader/' +this.$store.state.userInfo.userId+'/'+ this.fileForm.fileName
            }).then(res => {
              if (res.data.code == 200) {
                this.listLogByReaderIds()
              }
            })
          } else {
            return false;
          }
        });

      },
      listLogByReaderIds() {
        listLogByReaderId({
          readerId: this.$store.state.userInfo.userId
        }).then(res => {
          if (res.data.code == 200 && res.data.data.list) {
            this.selecdRource = res.data.data.list
          }
        })
      },
      sourceClick(item, index) {
        deleteFileOperation({
          readerId: this.$store.state.userInfo.userId,
          fileName: item.fileName,
          directory: item.directory
        }).then(res => {
          if (res.data.code == 200) {
            this.listLogByReaderIds()
          }
        })
      }
    },

    mounted() {
      // this.getPrivilege()
     this.rootUrl =  '/reader/'+this.$store.state.userInfo.userId+'/'
     this.uid = this.$store.state.userInfo.userId
      this.listLogByReaderIds()
    }
  }
</script>

<style lang="less" scoped>
  .resource {
    width: 62.5rem;
    min-height: 31.25rem;
    background: #fff;
    padding: 2.083rem 1.563rem;

    .upimg {
      padding-top: 2.635rem;
      margin-bottom: 0.569rem;
    }

    .submitBtn {
      width: 6.25rem;
      height: 2.396rem;
      background-color: #b1222b;
      border-radius: 0.208rem;
      color: #fff;
      font-size: 0.833rem;
      margin-left: 5.997rem;
    }

    /deep/ .el-upload-dragger {
      width: 34.896rem;
      height: 15.625rem;
      border-radius: 0.313rem;
      border: solid 0.052rem #bbbbbb;
    }

    /deep/ .form-sc {
      .el-form-item__error {
        left: 5.94rem;
      }
    }

    /deep/ .el-textarea {
      width: 34.896rem;
    }

    /deep/ .el-textarea :focus {
      border: solid 0.052rem #bbbbbb;
    }

    /deep/ .el-form-item__label {
      font-size: 1.042rem;
      line-height: 2.396rem;
    }

    /deep/ .el-input__inner {
      height: 2.396rem;
      border: solid 0.052rem #bbbbbb;
    }

    /deep/ .el-upload-list {
      width: 34.896rem;
      margin-left: 5.394rem;
    }

    .buying-source {
      position: relative;
      padding: 0.677rem 1.615rem 0.573rem 1.615rem;
      background-color: #ffffff;
      border-radius: 0.313rem;
      border: solid 0.052rem #cccccc;
      font-size: 0.833rem;
      letter-spacing: 0.016rem;
      color: #333333;
      margin-right: 1.563rem;
      width: auto;

      .buying-source-close {
        position: absolute;
        width: 0.885rem;
        height: 0.885rem;
        border-radius: 50%;
        border: solid 0.052rem #cccccc;
        background-color: #fff;
        cursor: pointer;
        right: -0.4425rem;
        top: -0.4425rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.6rem;
      }
    }
  }
</style>
